"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "worksheet",
    path: "/worksheets/:id",
    component: "Worksheet",
    params: [{
            name: "id",
            prop: "oid",
        },
    ]
});
let Worksheet = class Worksheet extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    formId;
    onForm_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("formId");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    item;
    async $$load_item() {
        return (this.oid === 'create' || this.oid == null)
            ? this.$fn.fetch('get_worksheet_template', { asResource: true })
            : this.$fn.fetch('read_worksheet', { parameters: { id: this.oid }, asResource: true });
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['item', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "full-screen",
                },
            },
        };
    }
    get isNew() {
        if (this.loaded) {
            return this.item.isNew;
        }
        return null;
    }
    get isReadonly() {
        if (this.loaded) {
            return false;
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.item.snapshot('number'),
                    this.$fn.gettext("Worksheet"),
                ],
                icon: this.$config.worksheet.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_5840_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async evh_8564662037462133_reload(event, scope) {
        return await this.actions.evh_8564662037462133_reload.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_reloadSlickgrid_5848_getActionArgs($event) {
        return {
            grid: "worksheets",
        };
    }
    async evh_8564662037462133_deleted(event, scope) {
        return await this.actions.evh_8564662037462133_deleted.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_reloadSlickgrid_5852_getActionArgs($event) {
        return {
            grid: "worksheets",
        };
    }
    async evh_1040167445267876_success_5851_getWhen($event) {
        return this.item.id;
    }
    async act_1040167445267876_closeComponent_5854_getActionArgs($event) {
        return {
            result: {
                close: true,
            },
        };
    }
    async evh_1040167445267876_success_5853_getWhen($event) {
        return !this.item.id;
    }
    async act_1040167445267876_navigate_5856_getActionArgs($event) {
        return {
            location: {
                name: "app.worksheet",
                params: {
                    id: $event.data.id,
                },
            },
        };
    }
    async evh_1040167445267876_success_5855_getWhen($event) {
        return !this.item.id;
    }
    async act_1040167445267876_setData_5858_getActionArgs($event) {
        return {
            path: "item",
            value: $event.data,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_1040167445267876_success_5857_getWhen($event) {
        return this.item.id && !!$event.data && !!$event.data.id;
    }
    async act_1040167445267876_form_5860_getActionArgs($event) {
        return {
            name: this.formId,
            reset: true,
        };
    }
    async evh_1040167445267876_success_5859_getWhen($event) {
        return this.item.id && !!$event.data && !!$event.data.id;
    }
    async act_1040167445267876_crud_5850_getActionArgs($event) {
        return {
            objectType: "worksheet",
            op: "upsert",
            data: this.item,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1468474219929533_reload(event, scope) {
        return await this.actions.evh_1468474219929533_reload.executeFromDOM(this, event, scope);
    }
    async evh_1306227577716690_reload(event, scope) {
        return await this.actions.evh_1306227577716690_reload.executeFromDOM(this, event, scope);
    }
    async evh_8723442106880637_reload(event, scope) {
        return await this.actions.evh_8723442106880637_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5840 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5840_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5839 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5840,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5839],
        });
        const act_2248226175642056_closeModal_5842 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_5841 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_5842,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_5841],
        });
        const act_8564662037462133_reloadComponentData_5844 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8564662037462133_reload_5843 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_reloadComponentData_5844,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_8564662037462133_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_reload_5843],
        });
        const act_8564662037462133_closeModal_5846 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_8564662037462133_deleted_5845 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_closeModal_5846,
            event: "deleted",
            displayName: "closeModal",
        });
        const act_8564662037462133_reloadSlickgrid_5848 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_8564662037462133_reloadSlickgrid_5848_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_deleted_5847 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_reloadSlickgrid_5848,
            event: "deleted",
            displayName: "reloadSlickgrid",
        });
        const evh_8564662037462133_deleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_deleted_5845, evh_8564662037462133_deleted_5847],
        });
        const act_1040167445267876_reloadSlickgrid_5852 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1040167445267876_reloadSlickgrid_5852_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_5851 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_reloadSlickgrid_5852,
            event: "success",
            when: this.evh_1040167445267876_success_5851_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_1040167445267876_closeComponent_5854 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_5854_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_5853 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_5854,
            event: "success",
            when: this.evh_1040167445267876_success_5853_getWhen,
            displayName: "closeComponent",
        });
        const act_1040167445267876_navigate_5856 = new core_1.actions.NavigateAction({
            actionArgs: this.act_1040167445267876_navigate_5856_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_5855 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_navigate_5856,
            event: "success",
            when: this.evh_1040167445267876_success_5855_getWhen,
            displayName: "navigate",
        });
        const act_1040167445267876_setData_5858 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1040167445267876_setData_5858_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_5857 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_setData_5858,
            event: "success",
            when: this.evh_1040167445267876_success_5857_getWhen,
            displayName: "setData",
        });
        const act_1040167445267876_form_5860 = new core_1.actions.FormAction({
            actionArgs: this.act_1040167445267876_form_5860_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_5859 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_form_5860,
            event: "success",
            when: this.evh_1040167445267876_success_5859_getWhen,
            displayName: "form",
        });
        const act_1040167445267876_crud_5850 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_5850_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_5851, evh_1040167445267876_success_5853, evh_1040167445267876_success_5855, evh_1040167445267876_success_5857, evh_1040167445267876_success_5859],
        });
        const evh_1040167445267876_submit_5849 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_5850,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_5849],
        });
        const act_1468474219929533_reloadComponentData_5862 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_1468474219929533_reload_5861 = new core_1.actions.EventHandlerImpl({
            action: act_1468474219929533_reloadComponentData_5862,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_1468474219929533_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1468474219929533_reload_5861],
        });
        const act_1306227577716690_reloadComponentData_5864 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_1306227577716690_reload_5863 = new core_1.actions.EventHandlerImpl({
            action: act_1306227577716690_reloadComponentData_5864,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_1306227577716690_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1306227577716690_reload_5863],
        });
        const act_8723442106880637_reloadComponentData_5866 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8723442106880637_reload_5865 = new core_1.actions.EventHandlerImpl({
            action: act_8723442106880637_reloadComponentData_5866,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_8723442106880637_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8723442106880637_reload_5865],
        });
        return {
            act_7315092382398562_closeModal_5840,
            evh_7315092382398562_close_5839,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_5842,
            evh_2248226175642056_close_5841,
            evh_2248226175642056_close,
            act_8564662037462133_reloadComponentData_5844,
            evh_8564662037462133_reload_5843,
            evh_8564662037462133_reload,
            act_8564662037462133_closeModal_5846,
            evh_8564662037462133_deleted_5845,
            act_8564662037462133_reloadSlickgrid_5848,
            evh_8564662037462133_deleted_5847,
            evh_8564662037462133_deleted,
            act_1040167445267876_reloadSlickgrid_5852,
            evh_1040167445267876_success_5851,
            act_1040167445267876_closeComponent_5854,
            evh_1040167445267876_success_5853,
            act_1040167445267876_navigate_5856,
            evh_1040167445267876_success_5855,
            act_1040167445267876_setData_5858,
            evh_1040167445267876_success_5857,
            act_1040167445267876_form_5860,
            evh_1040167445267876_success_5859,
            act_1040167445267876_crud_5850,
            evh_1040167445267876_submit_5849,
            evh_1040167445267876_submit,
            act_1468474219929533_reloadComponentData_5862,
            evh_1468474219929533_reload_5861,
            evh_1468474219929533_reload,
            act_1306227577716690_reloadComponentData_5864,
            evh_1306227577716690_reload_5863,
            evh_1306227577716690_reload,
            act_8723442106880637_reloadComponentData_5866,
            evh_8723442106880637_reload_5865,
            evh_8723442106880637_reload,
            save: act_1040167445267876_crud_5850,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], Worksheet.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Worksheet.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: function () {
            return this.$fn.randomElementId();
        },
    }),
    __metadata("design:type", String)
], Worksheet.prototype, "formId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('formId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Worksheet.prototype, "onForm_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "full-screen",
    }),
    __metadata("design:type", String)
], Worksheet.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Worksheet.prototype, "onSize", null);
Worksheet = __decorate([
    (0, vue_property_decorator_1.Component)()
], Worksheet);
exports.default = Worksheet;
vue_property_decorator_1.Vue.component("Worksheet", Worksheet);
